"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateContentMd5 = exports.calculateContentCRC32 = void 0;
var crc32_1 = require("./crc32");
Object.defineProperty(exports, "calculateContentCRC32", { enumerable: true, get: function () { return crc32_1.calculateContentCRC32; } });
var md5_1 = require("./md5");
Object.defineProperty(exports, "calculateContentMd5", { enumerable: true, get: function () { return md5_1.calculateContentMd5; } });
